// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addWishList as addWishListApi, AddWishListApiParameter } from "@bg/App/Services/WishListService";
import isApiError from "@insite/client-framework/Common/isApiError";
import { HandlerWithResult, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { CallAddWishListApi, chain } from "@insite/client-framework/Store/Pages/MyLists/Handlers/AddWishList";
import { WishListModel } from "@insite/client-framework/Types/ApiModels";

export interface AddWishListResult {
    wishListModel?: WishListModel;
    errorMessage?: string;
}

type HandlerType = HandlerWithResult<
    {
        apiParameter: AddWishListApiParameter;
        reloadWishLists?: boolean;
        onSuccess?: (addedWishList: WishListModel) => void;
        onError?: (errorMessage: string) => void;
    },
    AddWishListResult
>;

export const XngCallAddWishListApi: HandlerType = async props => {
    try {
        props.result.wishListModel = await addWishListApi(props.parameter.apiParameter);
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            props.result.errorMessage = error.errorJson.message;
            return;
        }
        throw error;
    }
};

replaceInChain(chain, CallAddWishListApi, XngCallAddWishListApi);
